<template>
  <x-container
    title="Discovery Tool"
    :additionalChildren="subNavChildren"
    :showSidebar="false"
    :showSubContainer="!checkProjectRoute"
  ></x-container>
</template>

<script>
import EventBus from '@/EventBus';
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'Dashboard',
  data() {
    return {
      isLeftDrawerPanOpen: true,
      tab: null,
      checkProjectRoute: window.location.href.indexOf('projects') !== -1
    };
  },
  computed: {
    checkRoute() {
      return window.location.href.indexOf('/discovery/overview') > -1;
    },
    subNavChildren() {
      return this.openProjects.map(project => ({
        closable: true,
        clickHandler: project => this.closeOpenProject(project.projectSlug),
        title: project.projectName,
        link: '',
        meta: {
          id: `discovery__project-${project.projectSlug}-tab`
        },
        onTabClick: this.changeToRoute,
        active: project.projectSlug === this.$route.params?.projectId,
        ...project
      }));
    },
    ...mapState({
      openProjects: state => state.discovery.openProjects
    })
  },
  mounted() {
    this.setActiveTab();
    EventBus.$on('MINIFY_LEFT', isLeftDrawerPanOpen => {
      this.isLeftDrawerPanOpen = isLeftDrawerPanOpen;
    });
  },
  beforeDestroy() {
    EventBus.$off('MINIFY_LEFT');
    EventBus.$off('GET_PROJECTS');
  },

  watch: {
    $route: function() {
      this.checkProjectRoute = window.location.href.indexOf('projects') !== -1;
      this.setActiveTab();
    }
  },

  methods: {
    ...mapGetters('discovery', ['getOpenProjects']),
    ...mapMutations('discovery', ['setOpenProjects']),
    closeOpenProject(projectSlug) {
      // this is from store
      let openProjects = this.getOpenProjects();
      let newList = openProjects.filter(
        project => project.projectSlug !== projectSlug
      );
      // update the store
      this.setOpenProjects(newList);
      this.setActiveTab();
      // if currently open project is being closed - move user to overview tab
      if (projectSlug === this.$route.params.projectId) {
        this.$nextTick(() => {
          this.$router.push({ path: '/discovery/overview' });
        });
      }
    },
    setActiveTab() {
      if (this.$route.params && this.$route.params.projectId) {
        this.tab = this.openProjects.findIndex(
          project => project.projectSlug === this.$route.params.projectId
        );
      } else {
        this.tab = 1234;
      }
    },
    changeToRoute(project) {
      let path = `/discovery/projects/${project.projectSlug}`;
      if (this.$route.params.projectId === project.projectSlug) {
        // project already open; no need to navigate
        return;
      }
      if (project.projectStatus === 'Archived') {
        path = path + '/archives';
      }
      this.$nextTick(() => {
        this.$router.push({
          path
        });
      });
    }
  }
};
</script>
